import { gql } from '@common/hooks';

export const CreateWorksProfile = gql`
  mutation createWorksProfile($input: CreateWorksProfileInput!) {
    createWorksProfile(input: $input) {
      worksProfile {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const UpdateWorksProfile = gql`
  mutation updateWorksProfile($id: ID!, $input: UpdateWorksProfileInput!) {
    updateWorksProfile(id: $id, input: $input) {
      worksProfile {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
